/**
 * Feito pelo agente netexperts
 * Módulo: AnalyticsObra — Tab Estoque (inventário / mix de unidades)
 * Data: 2026-06-14
 */
import { useState } from 'react'
import { useObraArea } from '../hooks/useObraAnalytics'
import { DETAIL_CONFIG } from '../config/areaAnalytics'
import { formatCurrency, formatNumber, formatPercent } from '../../../../utils/obraAnalytics'
import KpiCard from '../../../../Components/Analytics/KpiCard'
import DonutBreakdown from '../../../../Components/Analytics/DonutBreakdown'
import PerformanceBars from '../../../../Components/Analytics/PerformanceBars'
import MetricCard from '../components/MetricCard'
import ContratosFinanceiroPanel, { CONTRATOS_POR_PAGINA } from '../components/ContratosFinanceiroPanel'
import DrillDownTable from '../components/DrillDownTable'
import TabState from '../components/TabState'

const PALETTE = ['#10b981', '#3b82f6', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#ec4899', '#84cc16']

const EstoqueTab = ({ obraId, investidor, period }) => {
    const [buscaContrato, setBuscaContrato] = useState('')
    const [contratoPage, setContratoPage] = useState(0)
    const { data, loading, error } = useObraArea(
        obraId,
        'estoque',
        {
            inicio: period?.inicio,
            fim: period?.fim,
            search: buscaContrato || undefined,
            page: contratoPage,
            per_page: CONTRATOS_POR_PAGINA,
        },
        investidor
    )

    if (loading || error || !data) return <TabState loading={loading} error={error} />

    const c = data.cards
    const contratos = data.contratos || []
    const pag = data.contratosPaginacao || { page: 0, per_page: CONTRATOS_POR_PAGINA, total: 0, total_pages: 0 }
    const statusItems = (data.porStatus || []).map((r, i) => ({
        label: r.label,
        value: Number(r.quantidade),
        displayValue: `${formatNumber(r.quantidade)} un.`,
        color: PALETTE[i % PALETTE.length],
    }))
    const statusQtdItems = (data.porStatus || []).map((r) => ({ label: r.label, value: Number(r.quantidade), displayValue: `${formatNumber(r.quantidade)} un.` }))

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                <KpiCard title="Total de Unidades" value={formatNumber(c.total_unidades)} subtitle="Cadastradas até o período" />
                <MetricCard title="Disponíveis" value={c.disponiveis} format={formatNumber} subtitle="Status Disponível" />
                <KpiCard title="Quitadas" value={formatNumber(c.quitados)} subtitle="Pagas integralmente" />
                <KpiCard title="Locadas" value={formatNumber(c.locadas)} subtitle="Em locação" />
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                <KpiCard title="Em acerto" value={formatNumber(c.em_acerto)} subtitle="Negociação/ajuste" />
                <MetricCard title="% Vendido" value={c.pct_vendido} format={formatPercent} subtitle="Unidades vendidas / total" />
                <KpiCard title="% Comprometido" value={formatPercent(c.pct_comprometido)} subtitle="Fora de Disponível (status)" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <DonutBreakdown title="Distribuição por Status" items={statusItems} />
                <PerformanceBars title="Unidades por Status" items={statusQtdItems} />
            </div>

            <ContratosFinanceiroPanel
                title="Correlação financeira por contrato"
                subtitle="Resumo do período e detalhamento por contrato de venda."
                pctRecebido={c.pct_recebido_vendido}
                pctAReceber={c.pct_a_receber_vendido}
                contratos={contratos}
                paginacao={pag}
                onSearch={(term) => { setBuscaContrato(term); setContratoPage(0) }}
                onPageChange={setContratoPage}
                emptyMessage={buscaContrato ? 'Nenhum contrato encontrado para esta busca.' : 'Sem contratos correlacionados no período.'}
            />

            <DrillDownTable obraId={obraId} area="estoque" investidor={investidor} config={DETAIL_CONFIG.estoque} period={period} />
        </div>
    )
}

export default EstoqueTab
